import React, { useEffect, useState } from "react";
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import RTL from "../RTL/RTL";
import "Styles/layouts/_Intro-layout.scss";
import CssBaseline from "@material-ui/core/CssBaseline";
import { Link } from "react-router-dom";
import AppLogo from "Assets/svg/logo/logo.svg";
import AppLogoText from "Assets/svg/logo/logo-text.svg";
import AuthService from "Services/http/endpoints/AuthService";
import StatusHandler from "Helpers/StatusHandler";
import ValidationFailed from "./ValidationFailed";
import { SITEVALIDATION } from "Stores/actionTypes";

function Index(props) {
  const dispatch = useDispatch();
  const { rtlLayout, cwt } = useSelector((state) => ({
    rtlLayout: state.settings.rtlLayout,
    cwt: state.settings.cwt,
  }));
  const theme = createTheme({
    direction: rtlLayout ? "rtl" : "ltr",
  });

  useEffect(() => {
    checkValidation();
  }, []);

  const checkValidation = async () => {
    try {
      const response = await AuthService.getValidation();
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({
          type: SITEVALIDATION,
          cwt: {
            update: true,
            ...response.data.Value,
          },
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };

  return (
    <RTL>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <div className="introLayout">
          {cwt && cwt.update && (
            <div className="session-body">
              <ValidationFailed />
              {!cwt.Logo && (
                <Link
                  to="/"
                  className="link-logo"
                  hidden={cwt.Logo ? true : false}
                >
                  <img src={AppLogo} alt="session-logo" />
                  <img src={AppLogoText} alt="session-logo" />
                </Link>
              )}
              {cwt.Active && (
                <div className="introLayout-children">{props.children}</div>
              )}
            </div>
          )}
        </div>
      </MuiThemeProvider>
    </RTL>
  );
}

export default Index;
